import React from 'react';
import { InfoIcon } from '../../../assets/icons/svgicons';
import styles from "./Tooltip.module.scss";

const Tooltip = ({ className, heading, content, icon }) => {
    return (
        <>
            <span className={`${styles.tooltip_btn} ${className || ""}`}>
                {icon || <InfoIcon />}
                <div className={styles.tooltip}>
                    {
                        heading && <h4>{heading}</h4>
                    }
                    <p>
                        {content}
                    </p>
                </div>
            </span>
        </>
    )
}

export default Tooltip
